module.exports = __webpack_public_path__ + "img/catholic-super-illustration-library_message-computer.7ecdf23d.svg";